import { Component } from "react";
import { createPortal } from "react-dom";
import Loader from "../../../../../utils/Loader";
import { ToastContainer } from "react-toastify";
import { withRouter } from "../../../../../utils/withRouter";
import { connect } from "react-redux";
import { toastError, toastSuccess } from "../../../../../utils/constants";
import Modal from "react-modal";
import moment from "moment";
import AdminDrawer from "../../../../../common_components/admin_module_drawer";
import HeaderWithLogo from "../../../../../common_components/header_with_logo";
import Resizer from "react-image-file-resizer";
import {
    getVendorConfigurationList_action, insertUpdateVendorConfiguration_action, deleteVendorConfiguration_action,
    getVendorMasterList_action
} from "../../../../../actions/admin_module_action/master_action/exhibition_master_action/vendorConfiguration_action";

// Role names sent as UserType in dbo.udtDocumentRecipientMapping
const USER_TYPE_VISITOR = 'Visitor'
const USER_TYPE_VENDOR = 'Vendor'
const USER_TYPE_EXHIBITOR = 'Exhibitor'
const USER_TYPE_PARTNER = 'Partner'
const USER_TYPE_DELEGATE = 'Delegate'

class VendorConfiguration extends Component {
    constructor(props) {
        super(props)
        this.state = {
            isLoading: false,
            ExihibitionID: '',
            vendorConfigurationList: [],
            isAUOpen: false,
            isDelOpen: false,
            deleteID: '',
            VendorConfigurationID: '',
            Title: '',
            TitleErr: '',
            FilePath: '',
            FileType: '',
            FileName: '',
            File: '',
            FileErr: '',
            isFileDeleted: true,
            IsVisitor: false,
            IsVendor: false,
            IsExhibitor: false,
            IsPartner: false,
            IsDelegate: false,
            roleErr: '',
            // Vendor recipients (sp_get_Vendor_Master) — loaded when the Vendor role is ticked
            vendorMasterList: [],
            selectedVendorIds: [],
            vendorErr: '',
        }
        this.getVendorConfigurationList = this.getVendorConfigurationList.bind(this)
        this.getVendorMasterList = this.getVendorMasterList.bind(this)
        this.insertUpdateVendorConfiguration = this.insertUpdateVendorConfiguration.bind(this)
        this.deleteVendorConfiguration = this.deleteVendorConfiguration.bind(this)
        this.onFilePick = this.onFilePick.bind(this)
        this.onCrossClick = this.onCrossClick.bind(this)
        this.clearAUFields = this.clearAUFields.bind(this)
        this.renderRoles = this.renderRoles.bind(this)
        this.onVendorRoleChange = this.onVendorRoleChange.bind(this)
        this.onVendorSelect = this.onVendorSelect.bind(this)
        this.buildRecipientMappings = this.buildRecipientMappings.bind(this)
    }

    componentDidMount() {
        this.setState({
            ExihibitionID: this.props.location.state != null && this.props.location.state.ExihibitionID != null ?
                this.props.location.state.ExihibitionID : this.props.id != null && this.props.id != undefined ? this.props.id : '',
        })
        setTimeout(() => {
            this.getVendorConfigurationList()
        }, 200);
    }

    getVendorConfigurationList() {
        const { ExihibitionID } = this.state
        this.setState({ isLoading: true })
        this.props.getVendorConfigurationList_action(ExihibitionID)
            .then((data) => {
                if (data.error != 1) {
                    this.setState({
                        vendorConfigurationList: data.data != null && data.data != '' ? data.data : [],
                        isLoading: false
                    })
                }
                else {
                    this.setState({ isLoading: false })
                    toastError(data.msg)
                }
            })
            .catch((err) => {
                console.log(err)
            })
    }

    // Vendor recipients — ReceipientID comes from this list
    getVendorMasterList() {
        const { ExihibitionID } = this.state
        this.setState({ isLoading: true })
        this.props.getVendorMasterList_action(ExihibitionID)
            .then((data) => {
                if (data.error != 1) {
                    this.setState({
                        vendorMasterList: data.data != null && data.data != '' ? data.data : [],
                        isLoading: false
                    })
                }
                else {
                    this.setState({ isLoading: false })
                    toastError(data.msg)
                }
            })
            .catch((err) => {
                console.log(err)
            })
    }

    // sp_get_Vendor_Master row -> ReceipientID.
    // Column casing varies (Userid / UserID / ReceipientID), so match case insensitively.
    getVendorId(data) {
        var preferred = ['receipientid', 'receipentid', 'recipientid', 'accountid', 'vendorid', 'userid']
        var keys = Object.keys(data)
        for (var i = 0; i < preferred.length; i++) {
            var match = keys.find((k) => k.toLowerCase() == preferred[i])
            if (match != null && data[match] != null) { return data[match] }
        }
        return null
    }

    clearAUFields() {
        this.setState({
            VendorConfigurationID: '',
            Title: '',
            TitleErr: '',
            FilePath: '',
            FileType: '',
            FileName: '',
            File: '',
            FileErr: '',
            isFileDeleted: true,
            IsVisitor: false,
            IsVendor: false,
            IsExhibitor: false,
            IsPartner: false,
            IsDelegate: false,
            roleErr: '',
            vendorMasterList: [],
            selectedVendorIds: [],
            vendorErr: '',
        })
    }

    onAdd() {
        this.clearAUFields()
        this.setState({ isAUOpen: true })
    }

    // Recipient mapping rows returned by sp_get_VendorConfig, as [{ UserType, ReceipientID }]
    getRecipientMappings(data) {
        var mappings = data.RecipientMappings != null ? data.RecipientMappings : data.Recipients
        if (mappings == null || mappings == '') { return [] }
        if (typeof mappings == 'string') {
            try { mappings = JSON.parse(mappings) } catch (e) { return [] }
        }
        return Array.isArray(mappings) ? mappings : []
    }

    onUpdate(data) {
        var filePath = data.FilePath != null ? data.FilePath : ''
        var array = filePath != null && filePath != '' && filePath.split("/")
        const fileName = array.length > 0 ? array[array.length - 1] : ''

        var mappings = this.getRecipientMappings(data)
        var hasRole = (userType) => mappings.some((m) => m.UserType == userType)
        var selectedVendorIds = mappings
            .filter((m) => m.UserType == USER_TYPE_VENDOR && m.ReceipientID != null)
            .map((m) => m.ReceipientID)

        this.setState({
            isAUOpen: true,
            VendorConfigurationID: data.VendorConfigurationID,
            Title: data.Title,
            TitleErr: '',
            FilePath: filePath,
            FileType: '',
            FileName: fileName,
            File: '',
            FileErr: '',
            isFileDeleted: filePath == '' ? true : false,
            IsVisitor: hasRole(USER_TYPE_VISITOR),
            IsVendor: hasRole(USER_TYPE_VENDOR),
            IsExhibitor: hasRole(USER_TYPE_EXHIBITOR),
            IsPartner: hasRole(USER_TYPE_PARTNER),
            IsDelegate: hasRole(USER_TYPE_DELEGATE),
            roleErr: '',
            vendorMasterList: [],
            selectedVendorIds: selectedVendorIds,
            vendorErr: '',
        })

        // Pull the vendor list so the already mapped vendors show as ticked
        if (hasRole(USER_TYPE_VENDOR)) {
            this.getVendorMasterList()
        }
    }

    // Comma separated role names for the list column
    renderRoles(data) {
        var mappings = this.getRecipientMappings(data)
        var roles = []
        mappings.forEach((m) => {
            if (m.UserType != null && m.UserType != '' && !roles.includes(m.UserType)) {
                roles.push(m.UserType)
            }
        })
        return roles.length > 0 ? roles.join(", ") : '-'
    }

    onVendorRoleChange() {
        const { IsVendor, vendorMasterList } = this.state
        var isChecked = !IsVendor
        this.setState({ IsVendor: isChecked, roleErr: '', vendorErr: '' })
        if (isChecked) {
            if (vendorMasterList.length == 0) { this.getVendorMasterList() }
        } else {
            this.setState({ selectedVendorIds: [] })
        }
    }

    onVendorSelect(vendorId) {
        const { selectedVendorIds } = this.state
        var updated = selectedVendorIds.includes(vendorId) ?
            selectedVendorIds.filter((id) => id != vendorId) :
            [...selectedVendorIds, vendorId]
        this.setState({ selectedVendorIds: updated, vendorErr: '' })
    }

    // Columns exactly as returned by sp_get_Vendor_Master
    getVendorColumns() {
        const { vendorMasterList } = this.state
        return vendorMasterList.length > 0 ? Object.keys(vendorMasterList[0]) : []
    }

    isAllVendorSelected() {
        const { selectedVendorIds } = this.state
        var ids = this.getAllVendorIds()
        return ids.length > 0 && ids.every((id) => selectedVendorIds.includes(id))
    }

    // Unique, non null ids from the master list
    getAllVendorIds() {
        const { vendorMasterList } = this.state
        return [...new Set(vendorMasterList.map((data) => this.getVendorId(data)).filter((id) => id != null))]
    }

    onSelectAllVendors() {
        this.setState({
            selectedVendorIds: this.isAllVendorSelected() ? [] : this.getAllVendorIds(),
            vendorErr: ''
        })
    }

    // Build dbo.udtDocumentRecipientMapping rows for the save call
    buildRecipientMappings() {
        const { IsVisitor, IsVendor, IsExhibitor, IsPartner, IsDelegate, selectedVendorIds } = this.state
        var mappings = []
        if (IsVisitor) { mappings.push({ UserType: USER_TYPE_VISITOR, ReceipientID: null }) }
        if (IsExhibitor) { mappings.push({ UserType: USER_TYPE_EXHIBITOR, ReceipientID: null }) }
        if (IsPartner) { mappings.push({ UserType: USER_TYPE_PARTNER, ReceipientID: null }) }
        if (IsDelegate) { mappings.push({ UserType: USER_TYPE_DELEGATE, ReceipientID: null }) }
        // One row per selected vendor, carrying its ReceipientID
        if (IsVendor) {
            selectedVendorIds.forEach((id) => {
                mappings.push({ UserType: USER_TYPE_VENDOR, ReceipientID: id })
            })
        }
        return mappings
    }

    onFilePick = async (e, file) => {
        e.preventDefault()
        if (file.length != 0) {
            if (file[0]['size'] >= 10 * 1024 * 1024) {
                toastError('File size more than 10mb are not allow.')
            } else {
                var image = '';
                if (file[0]['name'].toString().toLowerCase().includes('.pdf') ||
                    file[0]['name'].toString().toLowerCase().includes('.jpeg') ||
                    file[0]['name'].toString().toLowerCase().includes('.png') ||
                    file[0]['name'].toString().toLowerCase().includes('.jpg')
                ) {
                    if (file[0]['name'].toString().toLowerCase().trim().includes('.jpg') ||
                        file[0]['name'].toString().toLowerCase().trim().includes('.png') ||
                        file[0]['name'].toString().toLowerCase().trim().includes('.jpeg')
                    ) {
                        image = await this.resizeFile(file[0]);
                    }
                    else if (file[0]['name'].toString().toLowerCase().trim().includes('.pdf')) {
                        image = await this.onPdfSelect(file[0]);
                    }

                    var fileType = file[0]['type']
                    var fileTypeList;
                    if (fileType.includes("/")) {
                        fileTypeList = fileType.split("/")
                    }
                    this.setState({
                        File: image,
                        FileName: file[0]['name'].toString(),
                        FileType: fileTypeList.length > 0 ? fileTypeList[1] : "",
                        FileErr: '',
                    })
                } else {
                    toastError('Only .pdf , .jpeg, .png, .jpg files are allowed')
                }
            }
        }
    }

    resizeFile = (file) =>
        new Promise((resolve) => {
            Resizer.imageFileResizer(
                file,
                500,
                600,
                'JPEG',
                80,
                0,
                (uri) => {
                    resolve(uri);
                },
                "base64",
                300,
                300,
            );
        });

    onPdfSelect = (file) =>
        new Promise((resolve) => {
            let base64;
            let fileReader = new FileReader();
            fileReader.onload = function (fileLoadedEvent) {
                base64 = fileLoadedEvent.target.result;
                resolve(base64);
            };
            fileReader.readAsDataURL(file);
        });

    onCrossClick() {
        this.setState({
            FilePath: '',
            FileType: '',
            FileName: '',
            File: '',
            isFileDeleted: true,
        })
    }

    insertUpdateVendorConfiguration() {
        const { ExihibitionID, VendorConfigurationID, Title, File, FileType, FilePath, FileName,
            IsVisitor, IsVendor, IsExhibitor, IsPartner, IsDelegate, selectedVendorIds } = this.state
        var err = false
        if (Title == '' || Title == null) {
            this.setState({ TitleErr: 'Please Enter Title' })
            err = true
        }
        if (FileName == '' || FileName == null) {
            this.setState({ FileErr: 'Please Upload File' })
            err = true
        }
        if (!IsVisitor && !IsVendor && !IsExhibitor && !IsPartner && !IsDelegate) {
            this.setState({ roleErr: 'Please Select Atleast 1 Role' })
            err = true
        }
        if (IsVendor && selectedVendorIds.length == 0) {
            this.setState({ vendorErr: 'Please Select Atleast 1 Vendor' })
            err = true
        }

        if (!err) {
            this.setState({ isLoading: true })
            this.props.insertUpdateVendorConfiguration_action(VendorConfigurationID, ExihibitionID, Title, File, FileType, FilePath,
                this.buildRecipientMappings())
                .then((data) => {
                    if (data.error != 1) {
                        toastSuccess("data saved successfully")
                        this.clearAUFields()
                        this.setState({ isAUOpen: false, isLoading: false })
                        setTimeout(() => {
                            this.getVendorConfigurationList()
                        }, 200);
                    }
                    else {
                        this.setState({ isLoading: false })
                        toastError(data.msg)
                    }
                })
                .catch((err) => {
                    console.log(err)
                })
        } else {
            toastError("Please fill mandatory fields")
        }
    }

    onDelete(id) {
        this.setState({ isDelOpen: true, deleteID: id })
    }

    deleteVendorConfiguration(id) {
        const { ExihibitionID } = this.state
        this.setState({ isLoading: true })
        this.props.deleteVendorConfiguration_action(ExihibitionID, id)
            .then((data) => {
                if (data.error != 1) {
                    toastSuccess("deleted successfully")
                    this.setState({ isLoading: false, isDelOpen: false, deleteID: '' })
                    setTimeout(() => {
                        this.getVendorConfigurationList()
                    }, 200);
                }
                else {
                    this.setState({ isLoading: false, isDelOpen: false })
                    toastError(data.msg)
                }
            })
            .catch((err) => {
                console.log(err)
            })
    }

    render() {
        const { isLoading, vendorConfigurationList, isAUOpen, isDelOpen, Title, TitleErr, FilePath, FileName, File, FileErr, isFileDeleted,
            IsVisitor, IsVendor, IsExhibitor, IsPartner, IsDelegate, roleErr,
            vendorMasterList, selectedVendorIds, vendorErr } = this.state

        return (
            <>
                {isLoading ? (
                    <Loader></Loader>
                ) : (
                    null
                )}

                <ToastContainer />
                <HeaderWithLogo />
                <>
                    <AdminDrawer />

                    <div className="main-container">
                        <div className="exb-topp">
                            <div className="row m-0 mb-2">
                                <div className="col-xl-12 mt-4">
                                    <div
                                        className="mb-1"
                                        aria-label="Basic example"
                                        style={{ float: "right" }}
                                    >
                                        <button type="button" className="btn btn-aqua mt-1"
                                            onClick={() => this.onAdd()}
                                        >
                                            Create
                                        </button>
                                    </div>
                                </div>
                            </div>
                            <div className="row p-2 mx-2">
                                <table class="table sticky-table text-nowrap table-bordered border-bottom border-2 mb-0 ">
                                    <thead class="table-light">
                                        <tr>
                                            <th className="text-center">Sr no.</th>
                                            <th className="text-center">Title</th>
                                            <th className="text-center">File</th>
                                            <th className="text-center">Role</th>
                                            <th className="text-center">Created By</th>
                                            <th className="text-center">Modified By</th>
                                            <th></th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {
                                            vendorConfigurationList.length > 0 ? <>{
                                                vendorConfigurationList.map((data, i) => (
                                                    <tr key={Math.random()}>
                                                        <td className="text-center">{i + 1}</td>
                                                        <td className="text-center">{data.Title}</td>
                                                        <td className="text-center">
                                                            {
                                                                data.FilePath != null && data.FilePath != '' ?
                                                                    <a href={data.FilePath} target="_blank" rel="noopener noreferrer">
                                                                        {data.FilePath.split("/")[data.FilePath.split("/").length - 1]}
                                                                    </a> : '-'
                                                            }
                                                        </td>
                                                        <td className="text-center">{this.renderRoles(data)}</td>
                                                        <td className="text-center">{data.CreatedBy != null && data.CreatedBy != '' ? data.CreatedBy : '-'}</td>
                                                        <td className="text-center">{data.ModifiedBy != null && data.ModifiedBy != '' ? data.ModifiedBy : '-'}</td>
                                                        <td className="text-center">
                                                            <i className="fa fa-pencil grid-icon border-end pe-2 me-2" aria-hidden="true"
                                                                onClick={() => this.onUpdate(data)}
                                                            />
                                                            <i className="fa fa-trash text-danger" aria-hidden="true"
                                                                onClick={() => this.onDelete(data.VendorConfigurationID)}
                                                            />
                                                        </td>
                                                    </tr>
                                                ))}
                                            </> :
                                                <tr><td colSpan={13} style={{ textAlign: 'center' }}>Record not found</td></tr>
                                        }
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </>

                {/* Add / Update Modal */}
                {isAUOpen &&
                    createPortal(
                        <div className="modal fade show vendor-config-modal"
                            style={{ display: 'block', backgroundColor: 'rgba(0,0,0,0.5)', zIndex: 9999, overflowY: 'auto' }}>
                            <div className="modal-dialog modal-dialog-centered">
                                <div className="modal-content">
                                    <div class="modal-header">
                                        <h4 class="modal-title modal_title_text">Layout Configuration</h4>
                                        <button type="button " class="close pop-close" data-dismiss="modal"
                                            onClick={() => this.setState({ isAUOpen: false })}
                                        ><span aria-hidden="true" class="pop-cancel">&times;</span></button>
                                    </div>
                                    <div class="modal-body" style={{ maxHeight: 'calc(100vh - 200px)', overflowY: 'auto' }}>
                                        <div className="row">
                                    <div class="col-md-12">
                                        <label for="validationCustom03">Title<span style={{ color: 'red' }}>*</span></label>
                                        <input
                                            value={Title}
                                            maxLength={200}
                                            onChange={(e) => this.setState({ Title: e.target.value, TitleErr: '' })}
                                            type="text" class="form-control" placeholder="Title" />
                                        {
                                            <span className="text-danger text-start text-left d-block mt-1">
                                                {TitleErr}
                                            </span>
                                        }
                                    </div>
                                    <div class="col-md-12 mt-2">
                                        <label htmlFor="validationCustom03">File<span style={{ color: 'red' }}>*</span></label>
                                        <div className="box">
                                            {isFileDeleted == false || FileName != '' ?
                                                <div style={{
                                                    border: '1px solid #ccc',
                                                    padding: '10px',
                                                    display: 'inline-flex',
                                                    alignItems: 'center',
                                                }}>
                                                    {isFileDeleted == false ?
                                                        <a href={FilePath} target="_blank" rel="noopener noreferrer">
                                                            <span style={{ marginRight: '10px' }}>{FileName}</span>
                                                        </a> :
                                                        <span style={{ marginRight: '10px' }}>{FileName}</span>}
                                                    <i className={`fa fa-times text-danger img-can`}
                                                        onClick={() => this.onCrossClick()}
                                                    ></i>
                                                </div>
                                                : <div className="upload-options mt-1">
                                                    <label style={{ display: 'flex' }}>
                                                        <input
                                                            type="file"
                                                            id="vendorConfigFile"
                                                            name="vendorConfigFile"
                                                            className="image-upload"
                                                            accept=".jpg, .jpeg, .png, .pdf"
                                                            onChange={e => this.onFilePick(e, e.target.files)}
                                                        />
                                                        {
                                                            File != "" &&
                                                            <i class="fa fa-times text-danger img-can"
                                                                onClick={() => this.onCrossClick()}
                                                            ></i>
                                                        }
                                                    </label>
                                                    <span className="text-danger" style={{ fontSize: '12px', display: 'block' }}>
                                                        Max 10MB | Jpeg,Jpg,Png,Pdf only
                                                    </span>
                                                </div>}
                                            {
                                                <span className="text-danger text-start text-left d-block mt-1">
                                                    {FileErr}
                                                </span>
                                            }
                                        </div>
                                    </div>
                                    <div class="col-md-12 mt-2">
                                        <label htmlFor="validationCustom03">Assign To<span style={{ color: 'red' }}>*</span></label>
                                        <div className="d-flex flex-wrap">
                                            <label style={{ marginRight: '15px' }}>
                                                <input type="checkbox" name="IsVisitor" className="mr-1"
                                                    style={{ verticalAlign: 'middle' }}
                                                    checked={IsVisitor}
                                                    onChange={() => this.setState({ IsVisitor: !IsVisitor, roleErr: '' })} /> Visitor
                                            </label>
                                            <label style={{ marginRight: '15px' }}>
                                                <input type="checkbox" name="IsVendor" className="mr-1"
                                                    style={{ verticalAlign: 'middle' }}
                                                    checked={IsVendor}
                                                    onChange={() => this.onVendorRoleChange()} /> Vendor
                                            </label>
                                            <label style={{ marginRight: '15px' }}>
                                                <input type="checkbox" name="IsExhibitor" className="mr-1"
                                                    style={{ verticalAlign: 'middle' }}
                                                    checked={IsExhibitor}
                                                    onChange={() => this.setState({ IsExhibitor: !IsExhibitor, roleErr: '' })} /> Exhibitor
                                            </label>
                                            <label style={{ marginRight: '15px' }}>
                                                <input type="checkbox" name="IsPartner" className="mr-1"
                                                    style={{ verticalAlign: 'middle' }}
                                                    checked={IsPartner}
                                                    onChange={() => this.setState({ IsPartner: !IsPartner, roleErr: '' })} /> Partner
                                            </label>
                                            <label style={{ marginRight: '15px' }}>
                                                <input type="checkbox" name="IsDelegate" className="mr-1"
                                                    style={{ verticalAlign: 'middle' }}
                                                    checked={IsDelegate}
                                                    onChange={() => this.setState({ IsDelegate: !IsDelegate, roleErr: '' })} /> Delegate
                                            </label>
                                        </div>
                                        {
                                            <span className="text-danger text-start text-left d-block mt-1">
                                                {roleErr}
                                            </span>
                                        }
                                    </div>

                                    {/* Vendor recipients — shown once the Vendor role is ticked */}
                                    {
                                        IsVendor &&
                                        <div class="col-md-12 mt-2">
                                            <label htmlFor="validationCustom03">Select Vendor<span style={{ color: 'red' }}>*</span></label>
                                            <div style={{ maxHeight: '300px', overflow: 'auto' }}>
                                                <table class="table sticky-table text-nowrap table-bordered border-bottom border-2 mb-0">
                                                    <thead class="table-light">
                                                        <tr>
                                                            <th className="text-center">
                                                                <input type="checkbox"
                                                                    style={{ verticalAlign: 'middle' }}
                                                                    disabled={vendorMasterList.length == 0}
                                                                    checked={this.isAllVendorSelected()}
                                                                    onChange={() => this.onSelectAllVendors()} />
                                                            </th>
                                                            {
                                                                this.getVendorColumns().map((col) => (
                                                                    <th key={col} className="text-center">{col}</th>
                                                                ))
                                                            }
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {
                                                            vendorMasterList.length > 0 ?
                                                                vendorMasterList.map((data, i) => {
                                                                    var vendorId = this.getVendorId(data)
                                                                    return (
                                                                        <tr key={`${vendorId}_${i}`}>
                                                                            <td className="text-center">
                                                                                <input type="checkbox"
                                                                                    style={{ verticalAlign: 'middle' }}
                                                                                    checked={selectedVendorIds.includes(vendorId)}
                                                                                    onChange={() => this.onVendorSelect(vendorId)} />
                                                                            </td>
                                                                            {
                                                                                this.getVendorColumns().map((col) => (
                                                                                    <td key={col} className="text-center">
                                                                                        {data[col] != null && data[col] !== '' ? String(data[col]) : '-'}
                                                                                    </td>
                                                                                ))
                                                                            }
                                                                        </tr>
                                                                    )
                                                                }) :
                                                                <tr><td colSpan={13} style={{ textAlign: 'center' }}>Record not found</td></tr>
                                                        }
                                                    </tbody>
                                                </table>
                                            </div>
                                            {
                                                <span className="text-danger text-start text-left d-block mt-1">
                                                    {vendorErr}
                                                </span>
                                            }
                                        </div>
                                    }
                                        </div>
                                    </div>
                                    <div class="modal-footer p-1">
                                        <div class="form-group text-right mod-fot">
                                            <button type="button" class="btn btn-aqua rounded-1 mt-3"
                                                onClick={() => this.insertUpdateVendorConfiguration()}
                                            >Submit</button>
                                            <button type="button" class="btn btn-gray rounded-1 mt-3" data-dismiss="modal" style={{ marginLeft: '5px' }}
                                                onClick={() => {
                                                    this.clearAUFields()
                                                    this.setState({ isAUOpen: false })
                                                }}
                                            >Back</button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>,
                        document.body
                    )
                }

                {/* Delete Modal */}
                <Modal isOpen={isDelOpen} onRequestClose={() => this.setState({ isDelOpen: false })}>
                    <div className="modal-dialog" style={{ marginTop: '20%' }}>
                        <div className="modal-content confirm-logout">
                            <div class="modal-header text-right p-2">
                                <h5 class="modal-title">Do you really want to delete this record?</h5>
                            </div>
                            <div class="modal-footer p-1">
                                <div class="form-group text-right mod-fot">
                                    <button type="button" class="btn btn-del-pop"
                                        onClick={() => this.deleteVendorConfiguration(this.state.deleteID)}
                                    >Yes</button>
                                    <button type="button" class="btn btn-gray" data-dismiss="modal" style={{ marginLeft: '5px' }}
                                        onClick={() => this.setState({ isDelOpen: false, deleteID: '' })}
                                    >No</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </Modal>
            </>
        );
    }
}

export default withRouter(connect(null, { getVendorConfigurationList_action, insertUpdateVendorConfiguration_action, deleteVendorConfiguration_action, getVendorMasterList_action })(VendorConfiguration));
